<template lang="pug">
div(:class="sizeClass")
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" offset-y :attach="attach" :max-height="menuHeight" max-width="min-content")
    template(#activator="{ on, attrs }")
      v-sheet.text-md.round-xl(v-bind="attrs" v-on="on" :class="error ? 'error-border-menu' : 'border-menu'" flat outlined min-width="240")
        v-row.py-1(no-gutters align="center" style="min-height: 47px;")
          v-col.pl-3
            v-row(v-if="value.length > 0" no-gutters)
              template(v-for="val in value")
                v-col.shrink.pa-1
                  v-chip.pl-2.pr-1(color="neutral300" label small)
                    span.pr-1.text-xs {{ val.value.substr(0, 40) }}{{ val.value.length > 40 ? '...' : '' }}
                    v-btn(icon x-small @click.stop="deselectItem(val)")
                      v-icon(size="14") mdi-close
            .text-sm.neutral500--text.ml-2(v-else) Select groups
          v-col.shrink.pr-4
            v-icon(size="24") $yzi-chevron-down
      div.text-xs.danger500--text.ml-3.mt-1.mb-2(v-show="error") This field is required

    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined :placeholder="$t('search_or_add_new')" dense hide-details autofocus)
        v-divider
        template(v-if="showCreateButton")
          y-button(:label="`Create group '${itemName.substr(0, 30)}${ itemName.length > 30 ? '...' : '' }'`" size="xs" color="transparent" text-color="neutral700" icon-color="neutral700" icon-size="15" underline button-class="px-4" @click="createGroup")
          v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      div(v-for="item in filteredItems")
        div.d-flex.align-center.px-4.py-3(v-if="isItemDisabled(item)" style="background-color: var(--v-neutral300)")
          div.text-sm.flex-grow-1.neutral700--text {{ item.value }}
        div.d-flex.align-center.px-4.py-3.clickable.hover-bg(v-else @click="selectItem(item)")
          div.text-sm.flex-grow-1.neutral700--text {{ item.value }}
          v-btn(x-small icon color="transparent" @click.stop="deleteItem(item)")
            v-icon(small color="neutral500") mdi-close
        v-divider
      template(v-if="!filteredItems.length")
        .px-4.py-3 No results match

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    error: {
      type: Boolean,
      default: false
    },
    attach: {
      type: Boolean,
      default: false
    },
    menuHeight: {
      type: String,
      default: '345'
    },
    overrideCompanyId: {
      type: [Number, String],
      default: null
    },
    teamHqId: {
      type: [Number, String],
      default: null
    },
    distinct: {
      type: Boolean,
      default: null
    },
    size: {
      type: String,
      default: null,
      validator: v => v === null || ['lg', 'md', 'sm'].includes(v)
    }
  },
  data: () => ({
    isLoading: false,
    isFetching: false,
    show: false,
    itemName: null,
    groups: [],
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    companyIdToUse() {
      return this.overrideCompanyId || this.company.id
    },
    showCreateButton() {
      if (this.itemName && (!this.filteredItems.length || !this.filteredItems.find(f => f.value.toLowerCase() === this.itemName.toLowerCase()))) {
        return true
      }
      return false
    },
    filteredItems() {
      if (this.itemName) {
        const keyword = this.itemName.toLowerCase()
        return this.groups.filter(item => (item.value.toLowerCase().includes(keyword)))
      }
      return this.groups
    },
    sizeClass() {
      if (!this.size) return ''
      return `yz-medication-group--${this.size}`
    },
  },
  watch: {
    show (val) {
      if (val) {
        this.fetchGroups()
      } else {
        this.$emit('change')
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchGroups () {
      this.isFetching = true
      const params = {
        enabled: true,
        field: 'medication.group',
        page_size: -1
      }
      if (this.teamHqId != null) {
        params.team_hq = this.teamHqId
      } else {
        params.company = this.companyIdToUse
      }
      if (this.distinct != null) params.distinct = this.distinct
      this.$axios.get('/options', { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.groups = resp.data.results
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    selectItem (item) {
      let data = this.value
      data.push(item)
      this.$emit('input', data)
      // this.show = false
      this.itemName = ''
    },
    deselectItem (item) {
      let data = this.value
      data.splice(data.map(m => m.id).indexOf(item.id), 1)
      this.$emit('input', data)
    },
    isItemDisabled(item) {
      return this.value.find(f => f.id === item.id)
    },
    createGroup () {
      this.isFetching = true
      let data = {
        company: this.companyIdToUse,
        field: 'medication.group',
        value: this.itemName,
        enabled: true
      }
      this.$axios.post('/options', data)
        .then(resp => {
          this.selectItem(resp.data)
          this.groups.push(resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    deleteItem (item) {
      this.isFetching = true
      this.$axios.delete(`/options/${item.id}/`)
        .then(() => {
          this.groups = this.groups.filter(f => f.id !== item.id)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    }
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
.yz-medication-group--lg >>> .v-sheet .row {
  min-height: 36px !important;
}
.yz-medication-group--md >>> .v-sheet .row {
  min-height: 32px !important;
}
.yz-medication-group--sm >>> .v-sheet .row {
  min-height: 28px !important;
}
</style>